import { Link } from "react-router-dom";
import { Lock, UserCheck, EyeOff, Ban, Trash2, ShieldCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  { icon: UserCheck, title: "Protected within your account", desc: "Each user's information is associated with and protected within their own account." },
  { icon: Lock, title: "Secure authentication", desc: "Nova uses secure authentication to help keep your account protected." },
  { icon: ShieldCheck, title: "Used to help you plan", desc: "Financial information is used to provide Nova's budgeting and planning functionality." },
  { icon: EyeOff, title: "No targeted advertising", desc: "Nova does not use personal or financial data for targeted advertising." },
  { icon: Ban, title: "Never sold", desc: "Nova does not sell personal or financial information." },
  { icon: Trash2, title: "Deletion on request", desc: "You can request account and data deletion at any time." },
];

export const Security = () => {
  return (
    <section id="security" className="relative scroll-mt-24 py-24 sm:py-32">
      <div className="container-nova">
        <Reveal>
          <p className="label-eyebrow mb-4">Security & Privacy</p>
          <h2 className="max-w-2xl font-heading text-3xl font-800 leading-tight tracking-tight text-white sm:text-5xl" style={{ fontWeight: 800 }}>
            Your data stays <span className="text-gradient-accent">yours</span>
          </h2>
          <p className="mt-4 max-w-2xl text-white/60">
            Privacy is built into how Nova works. Complete details are available in our Privacy Policy.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {POINTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={(i % 3) * 0.06}>
                <div className="h-full rounded-2xl border border-white/10 bg-white/[0.025] p-6" data-testid={`security-point-${i}`}>
                  <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-nova-emerald">
                    <Icon size={19} />
                  </div>
                  <h3 className="font-heading text-base font-semibold text-white">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-8">
            <Link to="/privacy" className="btn-ghost" data-testid="security-privacy-cta">
              Read the Privacy Policy
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Security;
